import { render, staticRenderFns } from "./showAcceptCompanyRequestDialog.vue?vue&type=template&id=1fbf0cce"
import script from "./showAcceptCompanyRequestDialog.vue?vue&type=script&lang=js"
export * from "./showAcceptCompanyRequestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports